import type APIResponseData from "~/types/APIResponseData";
import type Schema from "~/types/Schema";
import type SchemaChild from "~/types/SchemaChild";
import type SchemaParent from "~/types/SchemaParent";
import type DataType from "~/types/DataType";
import { DATATYPES } from "~/constants/dataTypes";

function useLowerCamelCase(item: APIResponseData<Schema | DataType> | SchemaChild | SchemaParent) {
  const path =
    item.fieldData?.dataType ??
    item.childDataType ??
    item.parentDataType ??
    (item.fieldData?.datatypeId ? "dataType" : "");

  // Things need to be camelCase, properties need to be lowerCamelCase
  return path.toLowerCase() !== "thing";
}

export default useLowerCamelCase;
